"use client";

import type { OrganizationPermissions } from "@/lib/orgs";
import type { B3OSVoiceToolsOptions, ConfirmationRequest, VoicePendingConfirmation } from "./voiceToolTypes";
import { CONFIRMABLE_RISKS } from "./voiceToolTypes";

export function createConfirmationResponse(meta: VoicePendingConfirmation) {
  return {
    ok: false,
    needsConfirmation: true,
    confirmation: meta,
    message: `Confirmation required for ${meta.action}. The user can confirm verbally or click the confirmation modal.`,
  };
}

export function requireConfirmation(options: B3OSVoiceToolsOptions, request: ConfirmationRequest) {
  if (!CONFIRMABLE_RISKS.has(request.risk)) {
    throw new Error(`Confirmation requested for non-confirmable risk: ${request.risk}`);
  }

  const meta = options.requestConfirmation(request);
  return createConfirmationResponse(meta);
}

export function ensureOrgId(options: B3OSVoiceToolsOptions) {
  if (!options.selectedOrgId) {
    throw new Error("No organization is selected.");
  }
  return options.selectedOrgId;
}

export function ensurePermission(options: B3OSVoiceToolsOptions, permission: keyof OrganizationPermissions) {
  if (options.currentOrgPermissions?.[permission] === false) {
    throw new Error(`Current organization role is not allowed to perform ${permission}.`);
  }
}
